import Ajax from "superagent"

/** #NOTE: 
 * Date.now() seems to be the fastest way to generate timestamps
 * I don't want the tracking to hurt performance or battery
 * life or nothin'
 * 
 * otoh, we're creating objects, which is expensive a.f., so may be try
 * to make this lighter byt sending just text and making the 
 * server work a bit more?
 * 
 * come to think of it, why do i need timestamps! the server can do that
 */

const dontTrack = new Set([
  "persist/REHYDRATE",
  "persist/PERSIST"
])

// #TODO may be debounce the posts?
// #TODO don't send the whole action when in production!

const trackerMiddleware = ({ _getState, _dispatch }) => next => action => {
  if (action.type == "@@router/LOCATION_CHANGE") {
    Ajax.post("/tracking")
      .send({
        eventType: "location", 
        pathname: action.payload.location.pathname, 
        timestamp: Date.now(),
        extra: action,
      })
      .then()
  }
  else if (action.type == "@@router/CALL_HISTORY_METHOD") {
    const pathname = (
      (action.payload.method == "goBack" && "BACK")
      || (action.payload.method == "push" && action.payload.args[0])
      || "WTF"
    )
      
    Ajax.post("/tracking")
      .send({
        eventType: "location", 
        pathname, 
        timestamp: Date.now(),
        extra: action,
      })
      .then()
  }
  else if (!dontTrack.has(action.type)) {
    Ajax.post("/tracking")
      .send({
        eventType: "redux-action",
        extra: action,
        timestamp: Date.now(),
      })
      .then()
  }

  next(action)
}

export default trackerMiddleware



// WEBPACK FOOTER //
// ./src/app/catalogo/store/tracker.js